/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
import { gsap } from "gsap";

console.log("Hello World! (from rastrotec-rastrotec block)2");
/* eslint-enable no-console */
// wait until DOM is ready
document.addEventListener("DOMContentLoaded", function (event) {
	console.log("DOM loaded");
	document.addEventListener("mousemove", (e) => {
		gsap.to(".earth-satellite-container .satellite", {
			x: ((e.clientX - window.innerWidth / 2) / window.innerWidth) * 60,
			y: ((e.clientY - window.innerHeight / 2) / window.innerHeight) * 50,
			duration: 1.5,
		});
		gsap.to(".earth-satellite-container .satellite", {
			rotation:
				((e.clientY - window.innerHeight / 2) / window.innerHeight) * 15,
			duration: 5,
		});
		gsap.to(".earth-satellite-container .earth", {
			x: ((e.clientX - window.innerWidth / 2) / window.innerWidth) * 5,
			y: ((e.clientY - window.innerHeight / 2) / window.innerHeight) * 5,
			duration: 4,
		});
		gsap.to(".earth-satellite-container .brasil", {
			x: ((e.clientX - window.innerWidth / 2) / window.innerWidth) * 30,
			y: ((e.clientY - window.innerHeight / 2) / window.innerHeight) * 30,
			duration: 4,
		});
	});

	//wait until images, links, fonts, stylesheets, and js is loaded
	window.addEventListener(
		"load",
		function (e) {
			//custom GSAP code goes here
			// This tween will rotate an element with a class of .my-element
			gsap.to(".hero-container", {
				rotation: 360,
				duration: 2,
				ease: "bounce.out",
			});

			console.log("window loaded");
		},
		false,
	);
});
